export default __webpack_public_path__ + "static/media/logo-ambiented.aa0f7b52.svg";